export default "__VITE_ASSET__C$R1h$Nu__"